<template>
  <BaseTypeNewForm
    base-type="discover"
    title="Neuen Entdecken-Eintrag anlegen"
    subtitle="Vergeben Sie einen Titel – Standort, Inhalte und Vermarktung pflegen Sie anschließend im Editor."
    legend="Eintrag benennen"
    input-label="Titel des Eintrags"
    hint="Tipp: Ein aussagekräftiger Titel hilft Gästen, Ihren Eintrag in der Übersicht schneller wiederzufinden."
    submit-label="Eintrag anlegen und bearbeiten"
    cancel-route-name="discover.index"
    :edit-route-name="editRouteName"
    require-category
    category-legend="Kategorie auswahlen"
    category-layout="rows"
  />
</template>

<script>
import BaseTypeNewForm from "@/components/base_type/BaseTypeNewForm.vue";
import {ROUTES} from "@/stores/constants";

export default {
  components: {
    BaseTypeNewForm,
  },
  computed: {
    editRouteName() {
      return ROUTES.DISCOVER.EDIT
    },
  },
}
</script>
